import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Quasar from 'quasar/src/vue-plugin.js';
import "@/styles/mainassets.scss";

//eslint-disable-next-line
// @ts-ignore
import quasarUserOptions from './quasar-user-options'
import { VueReCaptcha } from 'vue-recaptcha-v3'

createApp(App)
    .use(Quasar, quasarUserOptions)
    .use(store)
    .use(router)
    .use(VueReCaptcha, {
        siteKey: '6LfIczwkAAAAAB9dERNg1mExro2uC0hJchROYZF8', 
        loaderOptions: {
            autoHideBadge: true, 
            badge: 'bottomright', 
        },
        reCaptchaOptions: {

        }
    })
    .mount('#app')
